import { validatorRequire, validatorRequireNumber, validatorConditionalRequiredNumber } from '@/utils/validators';
import Select from '@/components/DSE/Select';
import PickRec from '@/components/DSE/PickRec/src/PickRec';
import FileUpload from '@/components/DSE/FileUpload';
import MDinput from '@/components/MDinput';
import { TemplateImageTypeOption } from '@/utils/constants';

export function getFormDefinition(vue) {
  return {
    name: {
      type: MDinput,
      defaultValue: null,
      props: {
        maxlength: 255,
        required: true
      },
      rules: [
        {
          validator: validatorRequire
        }
      ]
    },
    templateImageTypeOption: {
      type: Select,
      defaultValue: '',
      props: {
        caption: 'templateImage.templateImageTypeOption',
        valueField: 'code',
        labelField: 'description',
        loading: vue.$store.getters['option/isLoading'],
        options: vue.$store.getters['option/loadedOptions']('templateImageType'),
        required: true
      },
      rules: [{ validator: validatorRequireNumber }]
    },
    finishID: {
      type: PickRec,
      defaultValue: null,
      props: {
        caption: 'common.finish',
        valueField: 'id',
        labelField: 'finishTypeDescription',
        inputField: 'description',
        maxlength: 64,
        columns: [
          { field: 'description', label: 'common.finish' },
          { field: 'finishTypeDescription', label: 'common.finishType' }
        ],
        entity: 'Finish',
        required: true,
        usePagination: true,
        hideInput: false,
        suggest: true
      },
      dynamicProps: form => ({
        visible: form.templateImageTypeOption === TemplateImageTypeOption.Finish
      }),
      dynamicRules: form => [
        {
          validator: validatorConditionalRequiredNumber(form.templateImageTypeOption === TemplateImageTypeOption.Finish)
        }
      ]
    },
    documentFileName: {
      type: FileUpload,
      defaultValue: null,
      hideOnCreate: true,
      props: {
        hideOnCreate: true,
        caption: 'templateImage.templateDocument',
        uploadRoute: 'templateimage/file',
        deleteAction: 'templateImage/deleteFile',
        downloadAction: 'templateImage/downloadFile'
      }
    }
  };
}

const layout = {
  named: false,
  sections: [
    {
      width: 100
    }
  ]
};

export function getLayoutDefinition(vue) {
  return layout;
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
